// SingleProductView.tsx
import { Grid, Stack, TextField, Typography } from '@mui/material';
import { MissingPhoto } from 'Interfaces/IGlobalTypeConfig';
import { IProductViewModel } from 'Interfaces/IProductConfig';
import { GetColorByName } from 'functions/GetColorByName';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import Badge, { BadgeProps } from '@mui/material/Badge';
import shadows from '@mui/material/styles/shadows';
import { CompanyProductEditDrawer } from './Drawers/CompanyProductEditDrawer';
import EditIcon from '@mui/icons-material/Edit';
import { ConvertProductToCompanyAddProduct } from 'functions/Convert';

type Props = {
  index?: number;
  product: IProductViewModel;
};

const StyledBadge = styled(Badge)<BadgeProps>(() => ({
  '& .MuiBadge-badge': {
    border: 1,
    borderColor: 'primary.main',
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: shadows[3],
    fontSize: 28,
    height: 46,
    width: 46,
    borderRadius: '50%',
    fontWeight: 'bold',
    backgroundColor: 'primary.main',
    color: 'primary.contrastText',
  },
}));

export const SingleProductIListView = ({ product }: Props) => {
  const { t } = useTranslation();
  if (!product) {
    console.warn('SingleProductView: product is null/undefined');
    return null; // eller en enkel fallback-komponent
  }

  console.log('SingleProductView', product);
  let productVariant = product.paymentCycle === 0 ? 'Investment' : 'Agreement';
  let billingCycle = product.paymentCycle !== 0 ? product.bindingPeriod : 0;
  let paymentCycle = product.paymentCycle !== 0 ? product.paymentCycle : 0;
  let cycle =
    product.paymentCycle === 0 ? '' : `  ${paymentCycle} / ${billingCycle}`;

  return (
    <Grid
      container
      flexGrow={1}
      direction={'row'}
      sx={{
        mb: 1,
        borderLeft: 8,
        borderRight: 3,
        borderRadius: 3,
        borderColor: GetColorByName(product?.productType?.name).background,
        backgroundColor: !product.vendorProductUrl
          ? 'primary.main'
          : 'primary.main',
        ':hover': {
          cursor: 'pointer',
          filter: 'brightness(120%)',
          transition: 'all 0.2s ease-in-out',
        },
      }}
    >
      <Grid
        item
        sx={{
          p: 0.3,
          mt: 0,
          width: 88,
          height: 88,
          borderTopLeftRadius: '3px',
          borderBottomLeftRadius: '3px',
          backgroundColor: 'primary.light',
          display: 'flex',
        }}
      >
        <img
          src={product?.url ? product.url : MissingPhoto.PRODUCT_URL}
          style={{
            width: '100%',
            height: '100%',
            borderTopLeftRadius: '10px',
            borderBottomLeftRadius: '10px',
            objectFit: 'scale-down',
          }}
          alt={'logo'}
        />
      </Grid>

      <Grid
        item
        sx={{
          pl: 1,
          height: 88,
          flexGrow: 1,
        }}
      >
        <Stack direction={'column'}>
          <Typography
            sx={{
              letterSpacing: 1,
              textAlign: 'left',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              fontWeight: 'bold',
              fontSize: 18,
            }}
          >
            {product?.name} <span>{cycle}</span>
          </Typography>

          <Grid
            container
            direction={'row'}
            sx={{
              height: 56,
              display: 'flex',
              overflow: 'hidden',
            }}
          >
            {product?.features &&
              product?.features.map((_features: any, index: number) => {
                return (
                  <Grid item key={index} xs={6}>
                    <Grid container direction={'row'}>
                      <Grid item xs={6}>
                        <Typography
                          noWrap
                          sx={{
                            width: 110,
                            fontSize: 12,
                            letterSpacing: 1,
                            fontWeight: 'bold',
                            textAlign: 'left',
                            color: 'primary.text',
                          }}
                        >
                          {_features.featureName}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          noWrap
                          sx={{
                            fontSize: 12,
                            letterSpacing: 1,
                            fontWeight: 'normal',
                            textAlign: 'left',
                            color: 'primary.text',
                          }}
                        >
                          {_features.description}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                );
              })}
          </Grid>
        </Stack>
      </Grid>

      <Grid item xs={2} sx={{}}>
        <Stack direction={'column'}>
          <Typography
            noWrap
            sx={{
              pr: 1,
              letterSpacing: 0,
              textAlign: 'right',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              fontWeight: 'normal',
              textTransform: 'capitalize',
              fontSize: 14,
            }}
          >
            ({' '}
            {product?.brand?.brandName ||
              `${t('Products.SingleProductView.brand')}`}{' '}
            )
          </Typography>
          <Typography
            sx={{
              height: 64,
              pr: 1,
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'flex-end',
              alignContent: 'stretch',
              fontWeight: 'bold',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              textTransform: 'capitalize',
              color: 'secondary.text',
            }}
          >
            {(product?.retailPrice ?? 0).toFixed(2)}
          </Typography>
        </Stack>
      </Grid>
    </Grid>
  );
};
